import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import secondContactFormMeta, { ISecondContactFormMeta } from "./secondContactFormMeta";
import firstContactFormMeta, { IFirstContactFormMeta } from "./firstContactFormMeta";

export interface IApplicantAddressFormMeta extends IFirstContactFormMeta, ISecondContactFormMeta {
  addressType: FormInputMeta;
  address: FormInputMeta;
  city: FormInputMeta;
  street: FormInputMeta;
  postalBox: FormInputMeta;
  area: FormInputMeta;
  state: FormInputMeta;
  firstPhone: FormInputMeta;
  secondPhone: FormInputMeta;
  fax: FormInputMeta;

  schema: any;
}

let applicantAddressFormMeta = {} as IApplicantAddressFormMeta;

applicantAddressFormMeta.addressType = {
  name: "addressType",
  type: "select",
  label: "Type Adresse",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

applicantAddressFormMeta.address = {
  name: "address",
  type: "text",
  label: "Adresse",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

applicantAddressFormMeta.city = {
  name: "city",
  type: "select",
  label: "Ville",
  placeholder: "",
  validation: yup.string()
};

applicantAddressFormMeta.street = {
  name: "street",
  type: "text",
  label: "Rue",
  placeholder: "",
  validation: yup.string()
};

applicantAddressFormMeta.postalBox = {
  name: "postalBox",
  type: "text",
  label: "Boîte Postale",
  placeholder: "",
  validation: yup.string()
};

applicantAddressFormMeta.area = {
  name: "area",
  type: "text",
  label: "Zone",
  placeholder: "",
  validation: yup.string()
};

applicantAddressFormMeta.state = {
  name: "state",
  type: "text",
  label: "Etat",
  placeholder: "",
  validation: yup.string()
};

applicantAddressFormMeta.firstPhone = {
  name: "firstPhone",
  type: "text",
  label: "1er Téléphone",
  placeholder: "",
  validation: yup.string()
};

applicantAddressFormMeta.secondPhone = {
  name: "secondPhone",
  type: "text",
  label: "2ème Téléphone",
  placeholder: "",
  validation: yup.string()
};

applicantAddressFormMeta.fax = {
  name: "fax",
  type: "text",
  label: "Faxe",
  placeholder: "",
  validation: yup.string()
};

applicantAddressFormMeta = {...applicantAddressFormMeta, ...firstContactFormMeta, ...secondContactFormMeta}
applicantAddressFormMeta.schema = yup.object().shape(getValidationSchema(applicantAddressFormMeta));

export default applicantAddressFormMeta;